import styled from 'styled-components';
import { StyledLink } from '../styles/ui';
import { fontSemibold16, fontRegular14, fontSemibold14 } from '../styles/fonts';
import { Colors } from '../../../theme';
export { GroupName } from '../styles/ui';
export const CustomLink = styled(StyledLink) `
  display: flex;
`;
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 16px;

  .iconWrapper {
    margin-right: 16px;

    .MuiAvatar-root {
      font-size: 22px;
    }
  }

  .mainWrapper {
    display: flex;
    flex-direction: column;
  }

  .title {
    display: flex;
    align-items: center;
    ${fontSemibold16}
  }

  .description {
    ${fontRegular14}
  }
`;
export const Tag = styled.span `
  margin-left: 4px;
  padding: 0 6px;
  ${fontSemibold14}
  color: ${Colors.blue60};
  background-color: ${Colors.blue10};
  border-radius: 2px;
`;
//# sourceMappingURL=styles.js.map